<template>
    <div class="flex flex-wrap lg:flex-nowrap">
          <div class="w-full lg:w-2/3 pl-0">
            <table class=" mt-5 border-spacing-0 m-0 w-full  ">
              <tbody class="  w-full  border-spacing-0   ">
                <tr>
                  <td class="whitespace-nowrap py-1 text-xs   text-gray-900    text-center">
                    {{ $t('simbolos') }}:
                  </td>

                  <td class="whitespace-nowrap py-1   text-xs  text-gray-900    text-right">
                     {{ $t('activo')}}
                  </td>
                  <td class="whitespace-nowrap  py-1 text-xstext-gray-700 text-left">
                    
                    <span class='pl-2 green custom-shadow'></span>

                  </td>

                  <td class="whitespace-nowrap  py-1 pr-0 text-xs  text-gray-900      text-right">
                        {{ $t('falla_sensor')}}
                  </td>
                  <td class="whitespace-nowrap  py-1 text-xstext-gray-700">

                    <span class='pl-1 red custom-shadow'></span>
                  </td>

                  <td class="whitespace-nowrap py-1 pr-0 text-xs  text-gray-900  text-right">
                       <span v-html="$t('bajo_o2')"></span>
                  </td>
                  <td class="whitespace-nowrap  py-1 text-xstext-gray-700">

                    <span class='pl-1 yellow custom-shadow'></span>
                  </td>

                  <td class="whitespace-nowrap py-1 pr-0 text-xs  text-gray-900  text-right">
                     {{ $t('alto_orp')}}
                  </td>
                  <td class="whitespace-nowrap  py-1 text-xstext-gray-700">

                    <div
                      class="ml-2 rounded-full mb-1   flex items-center justify-center h-5 w-5 bg-orange-500 custom-shadow">
                      &nbsp;
                    </div>

                  </td>
                  <td class="whitespace-nowrap py-1 pr-0 text-xs  text-gray-900    text-right">
                      {{ $t('inhabilitado')}}
                  </td>
                  <td class="whitespace-nowrap  py-1 text-xstext-gray-700 ">


                    <div class=" ml-2 rounded-full mb-1   flex items-center justify-center h-5 w-5 bg-black  ">
                      &nbsp;
                    </div>

                  </td>
                  <td class="whitespace-nowrap py-1 pr-0 text-xs  text-gray-900    text-right">
                  {{ $t('inactivo')}}
                  </td>

                  <td class="whitespace-nowrap  py-1 text-xstext-gray-700 ">



                    <div
                      class=" ml-5 rounded-full mb-1   flex items-center justify-center h-5 w-5 bg-gray-400 custom-shadow">
                      &nbsp;
                    </div>

                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>

</template>



